module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/E-novels/e-novel-series/e-novel-series.component.css
// module id = ./src/app/E-novels/e-novel-series/e-novel-series.component.css
// module chunks = main